import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { X } from 'lucide-react';
import { useStore } from '@shared/hooks/useStore';

const ReaderNoteModal = observer(() => {
    const { readerStore } = useStore();
    const [content, setContent] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (!readerStore.isNoteModalOpen) {
            setContent('');
        }
    }, [readerStore.isNoteModalOpen]);

    if (!readerStore.isNoteModalOpen) return null;

    const handleAddNote = async () => {
        if (isSaving) return;

        setIsSaving(true);
        try {
            await readerStore.addNote(
                readerStore.selectedText,
                content.trim(),
                readerStore.selectedPosition
            );
            readerStore.closeNoteModal();
        } catch (error) {
            console.error('Failed to add note:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className='fixed inset-0 z-[100] flex items-center justify-center sm:p-4'>
            <div className='bg-[#29292B] sm:rounded-[20px] w-full h-full sm:h-auto sm:max-w-[500px] text-white relative overflow-hidden transition-all p-6 sm:p-8'>
                <div className='flex justify-between items-center mb-6'>
                    <h3 className='text-[18px] leading-[22px] font-black'>メモ</h3>
                    <button onClick={() => readerStore.closeNoteModal()}>
                        <X size={24} />
                    </button>
                </div>

                <div className='w-full flex flex-col gap-6'>
                    {/* <div className='flex items-center justify-center'>
                        <div className='bg-[#EDE074] w-[140px] h-[80px] rounded-[14px]' />
                    </div> */}

                    {/* Note Input */}
                    <textarea
                        value={content}
                        onChange={e => setContent(e.target.value)}
                        placeholder='メモを入力'
                        autoFocus
                        className='w-full bg-[#FFFFFF0A] border border-[#E7E7E71A] px-[15px] py-[10px] leading-[21px] min-h-[138px] focus:outline-none focus:border-primary transition-colors resize-none placeholder:text-[#666666]'
                        maxLength={500}
                    />

                    <div className='leading-[21px] text-[#666666]'>
                        {content.length}
                        /500
                    </div>

                    <div className='w-full h-[2px] bg-[#F9F9F91A]'></div>

                    <button
                        onClick={handleAddNote}
                        disabled={isSaving}
                        className={`w-full py-4 rounded-[10px] font-semibold text-white transition-all ${!isSaving ?
                            'bg-primary hover:bg-[#007347]' :
                            'bg-[#FFFFFF1A] text-[#FFFFFF4D] cursor-not-allowed'}`}
                    >
                        {isSaving ? '保存中...' : 'メモを追加'}
                    </button>
                </div>
            </div>
        </div>
    );
});

export default ReaderNoteModal;
